import i18n from 'scoreboard/components/i18n'
import initiativeCalculationTypes from 'scoreboard/initiatives/initiative-calculation-types'

var sortShowProps = function (props, property) {
	let sortFn = topLevelMenuPropSort
	if (property === bubblePropertyNames.SCHEDULE) {
		sortFn = scheduleSubmenuPropSort
	} else if (property === bubblePropertyNames.BUDGET) {
		sortFn = budgetSubmenuPropSort
	}
	return props.sort(function (a, b) {
		return sortFn(a).localeCompare(sortFn(b))
	})
}

/**
 * Property names that cannot be derived from
 * {@link initiativeCalculationTypes#showPropertyNames}
 */
const bubblePropertyNames = {
	// Present on all items
	LABEL: 'showLabel',

	// Shared between scorecard and initiative items
	DESCRIPTION: 'showDescription',
	PERIOD: 'showPeriod',
	COLOR: 'showColor',

	// Scorecards item specific
	ACTUAL: 'showActual',
	SCORE: 'showScore',
	TREND: 'showTrend',
	WEIGHT: 'showWeight',
	GOAL: 'showGoal',

	// Initiatives item specific
	START_DATE: 'showStartDate',
	END_DATE: 'showEndDate',
	PROJECTED_END_DATE: 'showProjectedEndDate',
	// Inititaves sub-menus
	SCHEDULE: 'scheduleSubMenu',
	BUDGET: 'budgetSubMenu'
}

// This looks kind of dumb, but basically we want to group some common fields
// right at the beginning, then sort the rest alphabetically
function topLevelMenuPropSort (option) {
	// Order is based on #28844
	if (option.property === bubblePropertyNames.LABEL) {
		return 'A'
	} else if (option.property === bubblePropertyNames.DESCRIPTION) {
		return 'B'
	} else if (option.property === bubblePropertyNames.PERIOD) {
		return 'C'
	} else if (option.property === bubblePropertyNames.ACTUAL) {
		return 'D'
	} else if (option.property === bubblePropertyNames.SCORE) {
		return 'E'
	}  else if (option.property === bubblePropertyNames.COLOR) {
		return 'F'
	} else if (option.property === bubblePropertyNames.GOAL) {
		return 'G'
	} else if (option.property === bubblePropertyNames.WEIGHT) {
		return 'H'
	} else if (option.property === bubblePropertyNames.TREND) {
		return 'I'
	} else if (option.property ===
		initiativeCalculationTypes.showPropertyName('percent-complete')) {
		return 'J'
	} else if (option.property === bubblePropertyNames.SCHEDULE) {
		return 'K'
	} else if (option.property === bubblePropertyNames.BUDGET) {
		return 'L'
	} else {
		return 'Z' + i18n.get(option.label)
	}
}

function scheduleSubmenuPropSort(option) {
	if (option.property === bubblePropertyNames.START_DATE) {
		return 'A'
	} else if (option.property === bubblePropertyNames.END_DATE) {
		return 'B'
	} else if (option.property ===
		initiativeCalculationTypes.showPropertyName('days-elapsed')) {
		return 'C'
	} else if (option.property ===
		initiativeCalculationTypes.showPropertyName('percent-time-elapsed')) {
		return 'D'
	} else if (option.property === bubblePropertyNames.PROJECTED_END_DATE) {
		return 'E'
	} else if (option.property ===
		initiativeCalculationTypes.showPropertyName('schedule-variance')) {
		return 'F'
	} else {
		return 'Z' + i18n.get(option.label)
	}
}

function budgetSubmenuPropSort(option) {
	if (option.property ===
		initiativeCalculationTypes.showPropertyName('budget')) {
		return 'A'
	} else if (option.property ===
		initiativeCalculationTypes.showPropertyName('budget-spent')) {
		return 'B'
	} else if (option.property ===
		initiativeCalculationTypes.showPropertyName('budget-remaining')) {
		return 'C'
	} else if (option.property ===
		initiativeCalculationTypes.showPropertyName('projected-budget')) {
		return 'D'
	} else if (option.property ===
		initiativeCalculationTypes.showPropertyName('budget-variance')) {
		return 'E'
	} else if (option.property ===
		initiativeCalculationTypes.showPropertyName('budget-variance-percent')) {
		return 'F'
	} else {
		return 'Z' + i18n.get(option.label)
	}
}

export {
	sortShowProps,
	bubblePropertyNames
}
